/**
 * Druid. Two-faced avatar (Arthurian Legends original printing).
 *
 * Card text (updated rules):
 *   FRONT (default state)
 *     "Tap → Play or draw a site. If this is your first turn, summon
 *      Tawny here.
 *      Tap → Summon Bruin here. Flip this card."
 *
 *   BACK (after flip)
 *     "UPDATED: Tap → Play or draw a site.
 *      Nearby allied sites have 'Whenever an enemy enters here, it
 *      takes 1 damage.'"
 *
 * Flip lifecycle is a ONE-WAY gameplay state change. Activating the
 * front-face's flip ability spawns Bruin at Druid's cell and flips
 * the avatar to the back face. The F hotkey (and the context-menu
 * flip option) is locked off by `flipPolicy: 'ability_only'` so a
 * stray keystroke can never accidentally activate the back-face aura.
 *
 * The Tawny-on-site-play passive (front face) and the back-face
 * damage trigger are deferred to Phase 2 of the implementation.
 * they need engine work (`on_enter_location` trigger +
 * site-granted-trigger primitive) that's reusable beyond Druid.
 */
export const DRUID_RULES = {
  // The avatar can only flip via the activated ability below. Any
  // other path (F hotkey, context-menu Flip option) is rejected by
  // `GameBoard.flipCard`.
  flipPolicy: 'ability_only',

  // Front-face activated ability. The flip trigger. Tap cost; the
  // handler (`GameBoard._doDruidFlip`) spawns a Bruin Beast token at
  // Druid's cell and then flips the avatar. After flip the back-face
  // override below empties this list so the ability cannot fire twice.
  extraActivatedAbilities: [
    {
      id: '__builtin_druid_flip',
      trigger: 'activated',
      cost: [{ type: 'tap' }],
      description: 'Summon Bruin and flip',
      _builtin: 'druid_flip',
    },
  ],

  // Back-face rule override. Applied by `resolveAvatarRules` when the
  // avatar instance carries `faceDown: true`. Drops the flip ability
  // and installs the site-granted damage trigger on nearby allied
  // sites. The granted trigger fires `on_enter_location` whenever an
  // enemy unit moves into a site's cell. Damage routes through the
  // unified `_applyDamageToTarget` pipeline (Ward / replacements /
  // Lethal / DD-immunity all honored for free).
  back: {
    extraActivatedAbilities: [],
    staticAuras: [
      {
        trigger: 'static',
        cost: [],
        condition: null,
        // The outer scope decides WHO receives the granted trigger:
        // nearby allied Sites (matches the card text "Nearby allied
        // sites have…"). `exclude_self` defaults true in the resolver
        // Druid itself is never a Site, so the flag is moot here.
        scope: { where: 'nearby', filter: { type: 'Site', allied: true } },
        duration: 'permanent',
        effect: [
          {
            op: 'grant_trigger_to_scope',
            args: {
              trigger_entry: {
                trigger: 'on_enter_location',
                condition: {
                  type: 'watch_target_filter',
                  enemy: true,
                  not_site: true,
                },
                effect: [{ op: 'damage_watch_target', args: { amount: 1 } }],
                duration: 'instant',
                scope: { where: 'self' },
              },
            },
          },
        ],
      },
    ],
  },
};
